import Layout from '@/layouts/Layout'

const activity = {
  path: '/activity',
  component: Layout,
  name: 'activity',
  meta: {
    title: '活动管理',
  },
  children: [
    {
      path: '/activity/coupon/list',
      name: 'activity_coupon_list_new',
      component: () => import('@/pages/activity/coupon/list/index.vue'),
      meta: { title: '优惠券活动列表', logEvent: '' },
    },
    {
      path: '/activity/coupon/grantRecord',
      name: 'activity_coupon_grant_record_new',
      hidden: true,
      component: () => import('@/pages/activity/coupon/grantRecord/index.vue'),
      meta: { title: '优惠券发放领取记录(发放明细)', logEvent: '' },
    },
    {
      path: '/activity/coupon/grantReceiveRecord',
      name: 'activity_coupon_grant_receive_record_new',
      hidden: true,
      component: () => import('@/pages/activity/coupon/grantReceiveRecord/index.vue'),
      meta: { title: '优惠券发放明细', logEvent: '' },
    },
    {
      path: '/activity/coupon/verifyRecord',
      name: 'activity_coupon_verify_record_new',
      hidden: true,
      component: () => import('@/pages/activity/coupon/verifyRecord/index.vue'),
      meta: { title: '优惠券核销明细', logEvent: '' },
    },
  ],
}

export default activity
